import config from '../../../config/App_data';
import GetData from '../../../RestAPI/getDataService';

const fetchReadingList = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/notes/reading`, data);
};

const pdfDownloadViaEmail = async data => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/cfa/notes/pdf-download-via-email`,
    data,
  );
};
module.exports = {
  fetchReadingList,
  pdfDownloadViaEmail,
};



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/ReadingList/ApiService.js